export default "__VITE_ASSET__CSilrEs0__ 480w, __VITE_ASSET__DqfmXhYq__ 800w, __VITE_ASSET__CF79Xav7__ 1200w, __VITE_ASSET__B6AiPeMa__ 1600w";